import { inject } from "@angular/core";
import { Router, ActivatedRouteSnapshot } from "@angular/router";
import { GeneralTermService } from "../back-office/Services/general-term.service";

export const acceptTermsResolver = (route: ActivatedRouteSnapshot) => {
  const generalTermService = inject(GeneralTermService);
  const router = inject(Router);

  return generalTermService.getTermByKey(route.params['token']).subscribe({
    next: (res) => res,
    error: () => router.navigateByUrl('/login')
  });
};
